import { genVr } from "../../core/utils";
import { BaseEntity, ModelEntity, ParentEntity } from "../../core/baseEntity.model";
import { AuthService } from "../core-services/auth.service";

export interface CheckoutSessionTrait {
    id: string;
    product: string;
    success_url: string;
    cancel_url: string;
}

const _parentName = "user_subscriptions";
// const _parentName = "${param:CUSTOMERS_COLLECTION}";

@ModelEntity({ name: "checkout_sessions", parentName: _parentName})
export class CheckoutSessionEntity extends BaseEntity<CheckoutSessionEntity> implements CheckoutSessionTrait {
    // @ParentEntity(_parentName, () => AuthService.instance.currentUser?.uid)
    // public userId: string;

    constructor(
        public id: string,
        public product: string,
        public success_url: string,
        public cancel_url: string,
        public metadata: any = {},
        public createdAt: number = Date.now(),
        public version: string = genVr()
    ) {
        super();
    }

    static async loadAll<C extends BaseEntity<C>>(id: string = AuthService.instance?.currentUser?.uid, {parentName, offset, ignoreStorageDbData, orderBy}: {parentName?: string; offset?: string; ignoreStorageDbData?: boolean; orderBy?: {
        column: keyof C;
        sort: 'asc' | 'desc'
    }} = {parentName: _parentName}): Promise<C[]> {
        super.setParent(_parentName, id);
        return super.loadAll(id, {parentName: parentName || _parentName, offset, orderBy, ignoreStorageDbData: ignoreStorageDbData || true});
    }

    static async persistMany<T = CheckoutSessionEntity>(data: T[]): Promise<boolean> {
        const id = AuthService.instance?.currentUser?.uid;
        super.setParent(_parentName, id);
        return super.persistMany<T>(data, id)
    }  
    public export<T = CheckoutSessionTrait>(): T {
        return {
            id: this.id,
            version: this.version,
            product: this.product,
            success_url: this.success_url,
            cancel_url: this.cancel_url,
            subscription_data: {
                trial_settings: {
                  end_behavior: {
                    missing_payment_method: 'cancel',
                  },
                },
                trial_period_days: 7,
                metadata: this.metadata || {},
            },
        } as any;
    }
}